import { Images, ImageType, ImageGroup, Image } from '@boels/models';

export function normalizeImages(source: Image[]): Images {
  const images: Images = {};

  if (source) {
    for (const image of source) {
      const isList = Object.prototype.hasOwnProperty.call(
        image,
        'galleryIndex',
      );

      const imageType = image.imageType as ImageType;
      const galleryIndex = image.galleryIndex as number;

      if (!Object.prototype.hasOwnProperty.call(images, imageType)) {
        images[imageType] = isList ? [] : {};
      }

      let imageContainer;

      if (isList && !(images[imageType] as ImageGroup[])[galleryIndex]) {
        (images[imageType] as ImageGroup)[galleryIndex] = {};
      }

      if (isList) {
        imageContainer = (images[imageType] as ImageGroup)[galleryIndex];
      } else {
        imageContainer = images[imageType];
      }

      const targetImage = { ...image };
      (imageContainer as ImageGroup)[image.format as string] = targetImage;
    }
  }
  return images;
}
